// app.store.ts
import {
  createAction,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  props,
} from '@ngrx/store';

// ! It enables to know if a cart is already paid, and avoid order duplication

export const CART_AVOID_ORDER_DUPLICATION_KEY = 'CartAvoidOrderDuplication';

// --- STATE ---
export interface CartAvoidOrderDuplication {
  hasCheckedForAssociatedPaidOrder: boolean;
}

export const initialState: CartAvoidOrderDuplication = {
  hasCheckedForAssociatedPaidOrder: false,
};

// --- ACTIONS ---
// Action to toggle loading indicator
export const SET_HAS_CHECKED_FOR_ASSOCIATED_PAID_ORDER = createAction(
  '[Dood/Cart] Has checked for associated paid order',
  props<{ isPaid: boolean }>(),
);

// --- REDUCER ---
// Reducer managing the global app state
export const CART_AVOID_ORDER_DUPLICATION_REDUCER = createReducer(
  initialState,
  on(SET_HAS_CHECKED_FOR_ASSOCIATED_PAID_ORDER, (state): CartAvoidOrderDuplication => ({
    ...state,
    hasCheckedForAssociatedPaidOrder: true,
  })),
);

// --- SELECTORS ---
// Feature selector for the global state
const selectGlobal = createFeatureSelector<CartAvoidOrderDuplication>('CartAvoidOrderDuplication');

// Selector to read the loading flag
export const SELECT_CART_HAS_CHECKED_FOR_ASSOCIATED_PAID_ORDER = createSelector(
  selectGlobal,
  state => state.hasCheckedForAssociatedPaidOrder,
);
